/**
 * Toast Action Type Constants
 * @type {string}
 */
export const CREATE_TOAST = 'CREATE_TOAST'
export const DELETE_TOAST = 'DELETE_TOAST'

/**
 * Create toast
 * @param message
 * @returns {{type: string, payload: *}}
 * @private
 */
export const _createToast = (message) => ({
  type: CREATE_TOAST,
  payload: message
})

/**
 * Delete toast
 * @param id
 */
export const _deleteToast = (id) => ({
  type: DELETE_TOAST,
  payload: id
})

/**
 * Dispatch CREATE_TOAST
 * @param message
 */
export const createToast = (message) => (dispatch) => {
  return dispatch(_createToast({ ...message, id: new Date().getTime() }))
}

/**
 * Dispatch DELETE_TOAST
 * @param id
 */
export const deleteToast = (id) => (dispatch) => {
  return dispatch(_deleteToast(id))
}
